import React from 'react'

import { assocIf } from '@btime/helpers'
import { useFilter } from '@btime/react-contexts'

const hasOnlyOne = prop => {
  return prop != null && Array.isArray(prop) && prop?.length === 1
}

export const useFormInitialStateFromFilter = () => {
  const filter = useFilter()

  return () => {
    return {
      ...assocIf(hasOnlyOne(filter?.checklistIds), 'checklist', filter?.checklistIds && filter?.checklistIds[0]),
      ...assocIf(hasOnlyOne(filter?.placeIds), 'place', filter?.placeIds && filter?.placeIds[0]),
      ...assocIf(hasOnlyOne(filter?.userIds), 'userOrGroup', filter?.userIds && filter?.userIds[0])
    }
  }
}
